import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = 'http://localhost:8081/api/admin/programs';

const ManagePrograms = () => {
  const [programs, setPrograms] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [programName, setProgramName] = useState('');
  const [editProgram, setEditProgram] = useState(null);

  // Load programs from backend
  useEffect(() => {
    fetchPrograms();
  }, []);

  const fetchPrograms = async () => {
    try {
      const res = await axios.get(API_URL);
      setPrograms(res.data);
    } catch (err) {
      console.error("Failed to fetch programs:", err);
    }
  };

  const openAddModal = () => {
    setProgramName('');
    setModalMode('add');
    setEditProgram(null);
    setModalOpen(true);
  };

  const openEditModal = (program) => {
    setProgramName(program.name);
    setModalMode('edit');
    setEditProgram(program);
    setModalOpen(true);
  };

  const saveProgram = async () => {
    if (!programName.trim()) return;

    try {
      if (modalMode === 'add') {
        const res = await axios.post(API_URL, { name: programName.trim() });
        setPrograms([...programs, { id: res.data.id, name: programName.trim() }]);
      } else if (modalMode === 'edit' && editProgram) {
        await axios.put(`${API_URL}/${editProgram.id}`, { name: programName.trim() });
        setPrograms(programs.map(p => p.id === editProgram.id ? { ...p, name: programName.trim() } : p));
      }

      setModalOpen(false);
      setProgramName('');
      setEditProgram(null);
    } catch (err) {
      console.error("Failed to save program:", err);
    }
  };

  const deleteProgram = async (id) => {
    if (!window.confirm("Are you sure you want to delete this program?")) return;

    try {
      await axios.delete(`${API_URL}/${id}`);
      setPrograms(programs.filter(p => p.id !== id));
    } catch (err) {
      console.error("Failed to delete program:", err);
    }
  };

  return (
    <div className="manage-programs manage-programs-semesters">
      <div className="header">
        <h2>Manage Programs</h2>
        <button className="add-btn" onClick={openAddModal}>Add Program</button>
      </div>

      <table className="programs-table">
        <thead>
          <tr>
            <th>Program Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {programs.map((program, index) => (
            <tr key={program.id}>
              <td>{program.name}</td>
              <td>
                <button className="edit" onClick={() => openEditModal(program)}>Edit</button>
                <button className="delete" onClick={() => deleteProgram(program.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalOpen && (
        <div className="manage-students__modal-overlay">
          <div className="manage-students__modal">
            <h3>{modalMode === 'add' ? "Add Program" : "Edit Program"}</h3>

            <input
              type="text"
              placeholder="Program Name"
              value={programName}
              onChange={(e) => setProgramName(e.target.value)}
            />

            <div className="manage-students__modal-actions">
              <button className="cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="save-btn" onClick={saveProgram}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagePrograms;
